import {h, Fragment} from "preact"
import { useCurrencyFormatting } from "@nosto/preact"

export default function Swatches({ product, relatedProducts }) {
    const { format } = useCurrencyFormatting()

    relatedProducts.sort((a, b)=>{
        if (a.productId == product.productId) return -1;
        if (b.productId == product.productId) return 1;
        return 0;
    })
      

    function handleSwatch(e, product, relatedProduct){
        //e.preventDefault();
        //e.stopImmediatePropagation();

        var prodElem = e.target.closest(".ns-product");
        prodElem.querySelector(".color-id.current_active_color")?.classList.remove("current_active_color");

        if(e.target.classList.contains("color-id")){
            e.target?.classList.add("current_active_color");
        } else {
            // e.target.querySelector(".color-id")?.classList.add("current_active_color");
            e.target.closest(".color-id")?.classList.add("current_active_color");
        }

        var newColor = relatedProduct?.tags1?.find(tag => tag.includes("color:"))?.split(":").pop();
        var newImg = relatedProduct?.imageUrl;
        var newHover = relatedProduct?.alternateImageUrls[0];
        var newProdId = relatedProduct?.productId;
        var newUrl = relatedProduct?.url;
        var newPrice = relatedProduct?.price;
        var newListPrice = relatedProduct?.listPrice;

        prodElem.querySelector(".pc-color-count i").textContent = newColor;
        prodElem.querySelector(".product-img > img").setAttribute("src", newImg);
        prodElem.querySelector(".hover-img img").setAttribute("src", newHover);
        prodElem.querySelectorAll(".coll-product-swatch").forEach((elem) => {
            elem?.classList.add("ns-d-none");
        })
        prodElem.querySelector(`.sizes-${newProdId}`)?.classList.remove("ns-d-none");
        if (prodElem.querySelector(".ns-more-swatches")) {
            prodElem.querySelector(".ns-more-swatches").setAttribute("href", newUrl);
        }
        prodElem.setAttribute("hit", product);
        prodElem.querySelector(".product-img").setAttribute("href", newUrl);
        prodElem.querySelector(".pc-price-discount").textContent = format(newPrice);

        if(newPrice != newListPrice){
            prodElem.querySelector(".pc-price-wp")?.classList.add("has_compare_price");
            prodElem.querySelector(".pc-price").textContent = format(newListPrice);
        } else {
            prodElem.querySelector(".pc-price-wp.has_compare_price")?.classList.remove("has_compare_price");
            prodElem.querySelector(".pc-price").textContent = '';
        }
    }

    const swatches = relatedProducts?.map((relatedProduct, index) => {
        let styleTag = relatedProduct.tags1.filter(tag => tag.toString().includes("style:") && !tag.toString().includes("new-style"));
        let variationTag = relatedProduct.tags1.filter(tag => tag.toString().includes("variation:"));
        let colorTag = relatedProduct.tags1.filter(tag => tag.toString().includes("color") && !tag.toString().includes("color-family"));
            
        // Extracting the first matching element and splitting
        let style = styleTag.length > 0 ? styleTag[0].split(":")[1].replaceAll(" ", "") : null;
        let variation = variationTag.length > 0 ? variationTag[0].split(":")[1].replaceAll(" ", "") : null;
        let color = colorTag.length > 0 ? colorTag[0].split(":")[1].replaceAll(" ", "") : null;

        // console.log("styleTag", styleTag, "variationTag", variationTag, "colorTag", colorTag)

        var isCurrent = relatedProduct.productId == product.productId;

        if(index < 4 || isCurrent) {
            return( 
                // <li class="color-box"  style={`${isCurrent ? 'order: -1' : ''}`} onClick={(e) => handleSwatch(e, product, relatedProduct)}>
                //     <div class={`color-id ${isCurrent ? 'current_active_color' : ''}`}
                //         dataid={relatedProduct.productId}
                //         style={`
                //             background: #e7e7e8;
                //             background-image: url('https://cdn.shopify.com/s/files/1/0238/2821/files/${style}-${variation}-${color}-Swatch.png');  
                //         `}
                //     ></div>
                // </li>

                // New Swatches
                <li style={`${isCurrent ? 'order: -1' : ''}`} onClick={(e) => handleSwatch(e, product, relatedProduct)}>
                    <div class={`color-id ${isCurrent ? 'current_active_color' : ''} color-swatches`}
                        dataid={relatedProduct.productId}>
                            <img src={relatedProduct.imageUrl} alt={relatedProduct.name} style="width: 100%; height: 100%; object-fit: cover;"/>
                        </div>
                </li>
            )
        }
    })

    return(
        <>
            <ul class="ns-align-items-center">
                {swatches}
                {relatedProducts?.length > 5 &&
                    <li><a class="ns-more-swatches" href={product.url}>+ {(relatedProducts?.length) - 5}</a></li>
                }
            </ul>
        </>
    )

}